/* eslint-disable prettier/prettier */
import Vue from "vue";
import Router from "vue-router";
// import appConfig from "@/config/application";
import Login from "./views/Login.vue";
import Home from "./views/Home.vue";
import ReqRegister from "./views/reqRegister.vue";
import ChkResultRequest from "./views/chkResultRequest.vue";
import ChkResultRegister from "./views/chkResultRegister.vue";
import Register from "./views/Register.vue";
import ChkClassByPlan from "./views/chkClassByPlan.vue";
import ChkOpenClass from "./views/chkOpenClass.vue";
import ChkRegisterResult from "./views/chkRegisterResult.vue";
import PrintStatement from "./views/printStatement.vue";
import ChkStudentInfo from "./views/chkStudentInfo.vue";
import Tor10 from "./views/Tor10.vue";
import Tor11 from "./views/Tor11.vue";
import ConfirmReqRegister from "./views/confirmReqRegister.vue";
import RandomReqRegister from "./views/randomReqRegister.vue";
import ReserveClass from "./views/reserveClass.vue";
import reportB5 from "./views/reportB5.vue";
import ListMenu from "./views/ListMenu.vue";
import DataTransfer from "./views/DataTransfer.vue";
import Payment from "./views/Payment.vue";
import updateRegisAmount from "./views/updateRegisAmount.vue";
import transferClassByCourse from "./views/transferClassByCourse.vue";
import transferClassByPerson from "./views/transferClassByPerson.vue";
import stuAdmissionStatusRec from "./views/stuAdmissionStatusRec.vue";
import permissionManageByCourses from "./views/permissionManageByCourses.vue";
import ListMenuP2 from "./views/ListMenuP2.vue";
import appReqLateRegis from "./views/appReqLateRegis.vue";
import chkResultsApprovalReqEnroll from "./views/chkResultsApprovalReqEnroll.vue";
import setCoorSchedForYearSem from "./views/setCoorSchedForYearSem.vue";
import setCoorSchedForCourse from "./views/setCoorSchedForCourse.vue";
import cancelReqEnrollment from "./views/cancelReqEnrollment.vue";
import setConditionCtrlEnroll from "./views/setConditionCtrlEnroll.vue";
import chkHConditionCancelCtrlEnroll from "./views/chkHConditionCancelCtrlEnroll.vue";
import cancelindividualEnroll from "./views/cancelindividualEnroll.vue";
import regisCoursesP from "./views/regisCoursesP.vue";
import registrationStatusLeave from "./views/registrationStatusLeave.vue";
import cancelRegisByCourse from "./views/cancelRegisByCourse.vue";
import setCreditStuProbation from "./views/setCreditStuProbation.vue";
import clearDataReqEnroll from "./views/clearDataReqEnroll.vue";
import regisStuForSet from "./views/regisStuForSet.vue";
import reqEnrollForSet from "./views/reqEnrollForSet.vue";
import logStudent from "./views/logStudent.vue";

import rpterpreenroll from "./views/reports/rpterpreenroll.vue";
import rpterstudentless9 from "./views/reports/rpterstudentless9.vue";
import rpterenrolllatefine from "./views/reports/rpterenrolllatefine.vue";
import rpterstdnotenroll from "./views/reports/rpterstdnotenroll.vue";
import rpterctstdnotenroll from "./views/reports/rpterctstdnotenroll.vue";
import rpterstdstatusmaintain from "./views/reports/rpterstdstatusmaintain.vue";
import rpterctstdstatusmaintain from "./views/reports/rpterctstdstatusmaintain.vue";
import rpterstdconfirmbyco from "./views/reports/rpterstdconfirmbyco.vue";
import rpterctstdconfirmbyco from "./views/reports/rpterctstdconfirmbyco.vue";
import rpterstdnotconfirmbyco from "./views/reports/rpterstdnotconfirmbyco.vue";
import rpterctstdnotconfirmbyco from "./views/reports/rpterctstdnotconfirmbyco.vue";
import rpterstdapprove from "./views/reports/rpterstdapprove.vue";
import rpterctstdapprove from "./views/reports/rpterctstdapprove.vue";
import rpterpreenrollbyco from "./views/reports/rpterpreenrollbyco.vue";
import rpterpreenrollbyinst from "./views/reports/rpterpreenrollbyinst.vue";
import rpterconfirmbyinst from "./views/reports/rpterconfirmbyinst.vue";
import rpterprebyenroll from "./views/reports/rpterprebyenroll.vue"; 
import rpterenrolloutprogram from "./views/reports/rpterenrolloutprogram.vue"; 
import rpterstdprenotconfirm from "./views/reports/rpterstdprenotconfirm.vue"; 
import rpterctstdprenotconfirm from "./views/reports/rpterctstdprenotconfirm.vue"; 
import rpterstdnotpreenroll from "./views/reports/rpterstdnotpreenroll.vue"; 
import rpterctstdnotpreenroll from "./views/reports/rpterctstdnotpreenroll.vue"; 
import rpterctstdnotpaid from "./views/reports/rpterctstdnotpaid.vue";
import rpterstdnotpaid from "./views/reports/rpterstdnotpaid.vue"; 
import rpterstdexam from "./views/reports/rpterstdexam.vue"; 
import rpterctstdexam from "./views/reports/rpterctstdexam.vue"; 
import rpterpaymentbydate from "./views/reports/rpterpaymentbydate.vue"; 

Vue.use(Router);

let ls = JSON.parse(localStorage.getItem("mfu-er-app"));

var router = new Router({
  // mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/datatransfer",
      name: "DataTransfer",
      component: DataTransfer
    },
    {
      path: "/payment",
      name: "Payment",
      component: Payment
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/listmenu",
      name: "ListMenu",
      component: ListMenu,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/",
      name: "home1",
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/home",
      name: "home2",
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/redirectback",
      beforeEnter() {
        console.log("Redirect --------------------------------> 2");
        location.href = `https://${process.env.VUE_APP_ER_OLD}/backend/`;
      }
    },
    {
      path: "/redirectold",
      beforeEnter() {
        debugger
        location.href = `https://${
          process.env.VUE_APP_ER_REG_OLD
        }/MFUER/DataTranfer.aspx?sessionguid=${
          ls.application && ls.application.userInfo.data.SESSIONGUID
            ? ls.application.userInfo.data.SESSIONGUID
            : ""
        }`;
      }
    },
    {
      path: "/redirecthome",
      beforeEnter() {
        console.log("Redirect --------------------------------> 1");
        location.href = `https://${process.env.VUE_APP_ER_OLD}/backend/`;
      }
    },
    {
      path: "/reqRegister",
      name: "reqRegister",
      component: ReqRegister,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/chkResultRequest",
      name: "chkResultRequest",
      component: ChkResultRequest,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/chkResultRegister",
      name: "chkResultRegister",
      component: ChkResultRegister,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/chkClassByPlan",
      name: "chkClassByPlan",
      component: ChkClassByPlan,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/chkOpenClass",
      name: "chkOpenClass",
      component: ChkOpenClass,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/chkRegisterResult",
      name: "chkRegisterResult",
      component: ChkRegisterResult,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/printStatement",
      name: "printStatement",
      component: PrintStatement,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/chkStudentInfo",
      name: "chkStudentInfo",
      component: ChkStudentInfo,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/tor10",
      name: "tor10",
      component: Tor10,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/tor11",
      name: "tor11",
      component: Tor11,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/confirmReqRegister",
      name: "confirmReqRegister",
      component: ConfirmReqRegister,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/randomReqRegister",
      name: "randomReqRegister",
      component: RandomReqRegister,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/reserveClass",
      name: "reserveClass",
      component: ReserveClass,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/reportB5",
      name: "reportB5",
      component: reportB5,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/updateRegisAmount",
      name: "updateRegisAmount",
      component: updateRegisAmount,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/transferClassByCourse",
      name: "transferClassByCourse",
      component: transferClassByCourse,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/transferClassByPerson",
      name: "transferClassByPerson",
      component: transferClassByPerson,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/stuAdmissionStatusRec",
      name: "stuAdmissionStatusRec",
      component: stuAdmissionStatusRec,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/permissionManageByCourses",
      name: "permissionManageByCourses",
      component: permissionManageByCourses,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/ListMenuP2",
      name: "ListMenuP2",
      component: ListMenuP2,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/appReqLateRegis",
      name: "appReqLateRegis",
      component: appReqLateRegis,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/chkResultsApprovalReqEnroll",
      name: "chkResultsApprovalReqEnroll",
      component: chkResultsApprovalReqEnroll,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/setCoorSchedForYearSem",
      name: "setCoorSchedForYearSem",
      component: setCoorSchedForYearSem,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/setCoorSchedForCourse",
      name: "setCoorSchedForCourse",
      component: setCoorSchedForCourse,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/cancelReqEnrollment",
      name: "cancelReqEnrollment",
      component: cancelReqEnrollment,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/setConditionCtrlEnroll",
      name: "setConditionCtrlEnroll",
      component: setConditionCtrlEnroll,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/chkHConditionCancelCtrlEnroll",
      name: "chkHConditionCancelCtrlEnroll",
      component: chkHConditionCancelCtrlEnroll,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/cancelindividualEnroll",
      name: "cancelindividualEnroll",
      component: cancelindividualEnroll,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/regisCoursesP",
      name: "regisCoursesP",
      component: regisCoursesP,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/registrationStatusLeave",
      name: "registrationStatusLeave",
      component: registrationStatusLeave,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/cancelRegisByCourse",
      name: "cancelRegisByCourse",
      component: cancelRegisByCourse,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/setCreditStuProbation",
      name: "setCreditStuProbation",
      component: setCreditStuProbation,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/clearDataReqEnroll",
      name: "clearDataReqEnroll",
      component: clearDataReqEnroll,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/regisStuForSet",
      name: "regisStuForSet",
      component: regisStuForSet,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/reqEnrollForSet",
      name: "reqEnrollForSet",
      component: reqEnrollForSet,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/logStudent",
      name: "logStudent",
      component: logStudent,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.1 ตรวจสอบผลการแจ้งความประสงค์ขอลงทะเบียนเรียนเป็นรายบุคคล
      path: "/rpterpreenroll",
      name: "rpterpreenroll",
      component: rpterpreenroll,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.2 ตรวจสอบผลการแจ้งความประสงค์ขอลงทะเบียนเรียนตามรายวิชา 
      path: "/rpterpreenrollbyco",
      name: "rpterpreenrollbyco",
      component: rpterpreenrollbyco,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.3 ตรวจสอบผลการแจ้งความประสงค์ขอลงทะเบียนเรียนตามอาจารย์ที่ปรึกษา
      path: "/rpterpreenrollbyinst",
      name: "rpterpreenrollbyinst",
      component: rpterpreenrollbyinst,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.4 ตรวจสอบรายชื่อนักศึกษาที่ได้รับอนุมัติให้ลงทะเบียนเรียน จำแนกตามอาจารย์ที่ปรึกษา
      path: "/rpterconfirmbyinst",
      name: "rpterconfirmbyinst",
      component: rpterconfirmbyinst,
      meta: {
        requiresAuth: true
      }
    },
    {
      //TOR 22.5 สรุปจำนวนที่เปิดรับเปรียบเทียบกับจำนวนนักศึกษาที่แจ้งความประสงค์ขอลงทะเบียนเรียน
      path: "/rpterprebyenroll",
      name: "rpterprebyenroll",
      component: rpterprebyenroll,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.6 รายชื่อนักศึกษาที่แจ้งความประสงค์เกิน 9 หน่วยกิต แต่ได้รับอนุมัติต่ำกว่า 9 หน่วยกิต
      path: "/rpterstudentless9",
      name: "rpterstudentless9",
      component: rpterstudentless9,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.7 รายชื่อนักศึกษาที่ลงทะเบียนรายวิชาที่ไม่มีในโครงสร้างหลักสูตร
      path: "/rpterenrolloutprogram",
      name: "rpterenrolloutprogram",
      component: rpterenrolloutprogram,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.8 รายชื่อนักศึกษาที่ลงทะเบียนล่าช้าพร้อมค่าปรับ
      path: "/rpterenrolllatefine",
      name: "rpterenrolllatefine",
      component: rpterenrolllatefine,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.9 รายชื่อนักศึกษาที่ยังไม่มาทำการลงทะเบียนเรียน
      path: "/rpterstdnotenroll",
      name: "rpterstdnotenroll",
      component: rpterstdnotenroll,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.10 จำนวนนักศึกษาที่ยังไม่มาทำการลงทะเบียนเรียน
      path: "/rpterctstdnotenroll",
      name: "rpterctstdnotenroll",
      component: rpterctstdnotenroll,
      meta: {
        requiresAuth: true
      }
    },
    {
      //TOR 22.11 รายชื่อนักศึกษาที่ไม่ชำระค่าธรรมเนียมการศึกษา
      path: "/rpterstdnotpaid",
      name: "rpterstdnotpaid",
      component: rpterstdnotpaid,
      meta: {
        requiresAuth: true
      }
    },
    {
      //TOR 22.12 จำนวนนักศึกษาที่ไม่ชำระค่าธรรมเนียมการศึกษา
      path: "/rpterctstdnotpaid",
      name: "rpterctstdnotpaid",
      component: rpterctstdnotpaid,
      meta: {
        requiresAuth: true
      }
    },
    {
      //TOR 22.11 - 12 รายชื่อนักศึกษาที่ไม่ชำระค่าธรรมเนียมการศึกษา
      path: "/rpterpaymentbydate",
      name: "rpterpaymentbydate",
      component: rpterpaymentbydate,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.13 รายชื่อนักศึกษาที่ได้รับอนุมัติให้ลงทะเบียนเรียน จำแนกตามรายวิชา
      path: "/rpterstdconfirmbyco",
      name: "rpterstdconfirmbyco",
      component: rpterstdconfirmbyco,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.14 จำนวนนักศึกษาที่ได้รับอนุมัติให้ลงทะเบียนเรียน จำแนกตามรายวิชา
      path: "/rpterctstdconfirmbyco",
      name: "rpterctstdconfirmbyco",
      component: rpterctstdconfirmbyco,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.15 รายชื่อนักศึกษาที่ไม่ได้รับอนุมัติให้ลงทะเบียนเรียน จำแนกตามรายวิชา
      path: "/rpterstdnotconfirmbyco",
      name: "rpterstdnotconfirmbyco",
      component: rpterstdnotconfirmbyco,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.16 จำนวนนักศึกษาที่ไม่ได้รับอนุมัติให้ลงทะเบียนเรียน จำแนกตามรายวิชา
      path: "/rpterctstdnotconfirmbyco",
      name: "rpterctstdnotconfirmbyco",
      component: rpterctstdnotconfirmbyco,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.17 รายชื่อนศที่ยืนยันแจ้งความประสงค์ลงทะเบียนเรียน
      path: "/rpterstdapprove",
      name: "rpterstdapprove",
      component: rpterstdapprove,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.18 จำนวนนศ.ที่ยืนยันแจ้งความประสงค์ลงทะเบียนเรียน
      path: "/rpterctstdapprove",
      name: "rpterctstdapprove",
      component: rpterctstdapprove,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.19 รายชื่อนักศึกษาที่ไม่ได้แจ้งความประสงค์ขอลงทะเบียนเรียน
      path: "/rpterstdnotpreenroll",
      name: "rpterstdnotpreenroll",
      component: rpterstdnotpreenroll,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.20 จำนวนนักศึกษาที่ไม่ได้แจ้งความประสงค์ขอลงทะเบียนเรียน
      path: "/rpterctstdnotpreenroll",
      name: "rpterctstdnotpreenroll",
      component: rpterctstdnotpreenroll,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.21 รายชื่อนักศึกษาที่ลงทะเบียนเรียนโดยมีตารางสอบซ้ำซ้อน
      path: "/rpterstdexam",
      name: "rpterstdexam",
      component: rpterstdexam,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.22 จำนวนนักศึกษาที่ลงทะเบียนเรียนโดยมีตารางสอบซ้ำซ้อน
      path: "/rpterctstdexam",
      name: "rpterctstdexam",
      component: rpterctstdexam,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.23 รายชื่อนักศึกษาที่แจ้งความประสงค์ขอลงทะเบียนเรียนแต่ยังไม่ยืนยัน
      path: "/rpterstdprenotconfirm",
      name: "rpterstdprenotconfirm",
      component: rpterstdprenotconfirm,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.24 จำนวนนักศึกษาที่แจ้งความประสงค์ขอลงทะเบียนเรียนแต่ยังไม่ยืนยัน
      path: "/rpterctstdprenotconfirm",
      name: "rpterctstdprenotconfirm",
      component: rpterctstdprenotconfirm,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.25 รายชื่อนักศึกษาที่ลงทะเบียนรักษาสถานภาพ / ลาพัก
      path: "/rpterstdstatusmaintain",
      name: "rpterstdstatusmaintain",
      component: rpterstdstatusmaintain,
      meta: {
        requiresAuth: true
      }
    },
    {
      // TOR 22.26 จำนวนนักศึกษาที่ลงทะเบียนรักษาสถานภาพ / ลาพัก
      path: "/rpterctstdstatusmaintain",
      name: "rpterctstdstatusmaintain",
      component: rpterctstdstatusmaintain,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  let isAuth = true;
  let byBass = false;
  console.log('to', to)
  console.log('next', next)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    console.log('to.matched.some')

    ls = JSON.parse(localStorage.getItem("mfu-er-app"));
    if (ls == undefined || ls == null) {
      isAuth = false;
    } else if (
      ls.application &&
      (ls.application.token === undefined ||
        ls.application.token == null ||
        !ls.application.token ||
        ls.application.token == "" ||
        ls.application.isExpired === undefined ||
        ls.application.isExpired == null ||
        ls.application.isExpired ||
        ls.application.isExpiredTemp === undefined ||
        ls.application.isExpiredTemp == null ||
        ls.application.isExpiredTemp)
    ) {
      isAuth = false;
    } else if(to.path !== "/" && to.path !== "/datatransfer") {
      const pathStudentExists = ls.application.studentInfo.menus.some(item => item.MENU_NAVIGATIONURL_NEW === to.path);
      const pathUserExists = ls.application.userInfo.menus.some(item => item.MENU_NAVIGATIONURL_NEW === to.path);
      if (!pathUserExists && !pathStudentExists) {
        isAuth = false;
      }
    }
  } else {
    // eslint-disable-next-line prettier/prettier
    console.log('byBass = true')

    byBass = true;
  }
  if (isAuth || byBass) {
    // eslint-disable-next-line prettier/prettier
    console.log('isAuth || byBass', isAuth || byBass)

    next();
  } else {
    next({ path: "/redirecthome" });
  }
});

export default router;
